<template>
  <div class="max-w-[400px] flex flex-col items-center" v-if="messageData && messageData?.text">
    <i class="fa-regular fa-circle-xmark fa-4x text-red-600"/>
    <div class="font-bold text-red-600 text-lg leading-5 mt-3">Access Denied</div>
    <div class="font-normal text-black text-base leading-5 mt-2 mb-4">{{ messageData.text }}</div>
    <el-button type="danger" @click="handleReLogIn">Қайта кириш</el-button>
  </div>
</template>

<script>

import store from "@/store";

export default {
  name: "AuthorizationNotification",
  props: {
    messageData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleReLogIn() {
      store.dispatch('logOut', store.state.keycloak)
    }
  }
}
</script>